import type { ReactNode } from 'react';

import { AuthProvider } from '@/app/providers/AuthContext';
import { ToastProvider } from '@/shared/ui-kit/ToastProvider/ToastProvider';

export const AppProviders = ({ children }: { children: ReactNode }) => (
    <ToastProvider>
      <AuthProvider>
        {children}
      </AuthProvider>
    </ToastProvider>
  );